

export const addFavorite = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const favoritesRef = firebase.firestore().collection('users/' + userId + '/favorites').doc(project.id);

    favoritesRef.get().then((doc)=>{if (doc.exists){
      if(doc.data().favorite){favoritesRef.set({favorite:false}).then(() => {
      dispatch({ type: 'REMOVE_FAVORITE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'REMOVE_FAVORITE_ERROR' }, err);
    });}
        else {favoritesRef.set({favorite:true}).then(() => {
      dispatch({ type: 'ADD_FAVORITE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADD_FAVORITE_ERROR' }, err);
    });}
     }
      else {
       favoritesRef.set({favorite:true}).then(() => {
      dispatch({ type: 'ADD_FAVORITE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADD_FAVORITE_ERROR' }, err);
    }); 
      }
  })
  }
};

export const addFavorite2 = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const favoritesRef = firebase.firestore().collection('favorites').doc(userId);
    const restaurantId = project.restaurantId;

    favoritesRef.get().then((doc)=>{if (doc.exists){
      if(doc.data()[[restaurantId]]){favoritesRef.update({[restaurantId]:false}).then(() => {
      dispatch({ type: 'REMOVE_FAVORITE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'REMOVE_FAVORITE_ERROR' }, err);
    });}
        else {favoritesRef.update({[restaurantId]:true}).then(() => {
      dispatch({ type: 'ADD_FAVORITE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADD_FAVORITE_ERROR' }, err);
    });}
     }
      else {
       favoritesRef.set({[restaurantId]:true}).then(() => {
      dispatch({ type: 'ADD_FAVORITE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADD_FAVORITE_ERROR' }, err);
    }); 
      }
  })
  }
};


export const createRestaurant = (project, id, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const authorId = getState().firebase.auth.uid;
    firebase.firestore().collection('pendingCreate').add({
      ...project,
      authorId: authorId,
      createdAt: new Date()
    }).then(() => {
      dispatch({ type: 'CREATE_PROJECT_SUCCESS' });
      if(callback){
        callback();  
      }
    }).catch(err => {
      dispatch({ type: 'CREATE_PROJECT_ERROR' }, console.log(err));
    });
  }
};

export const updateAdTracker = (link) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    var userId = getState().firebase.auth.uid;
    if(!userId){
      userId = 'signInPage';
    }
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    firebase.firestore().collection('adTracker').add({
      userId: userId,
      clickedAt: timestamp,
      link: link
    }).then(() => {
      dispatch({ type: 'AD_CLICK_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'AD_CLICK_ERROR' }, console.log(err));
    });
  }
};

export const createRestaurantAdmin = (project, id, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const authorId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    firebase.firestore().collection('restaurants').add({
      ...project,
      authorId: authorId,
      createdAt: timestamp
    }).then(() => {
      dispatch({ type: 'CREATE_PROJECT_SUCCESS' });
      callback();
    }).catch(err => {
      dispatch({ type: 'CREATE_PROJECT_ERROR' }, console.log(err));
    });
  }
};

export const editRestaurant = (project, id, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    console.log(firebase.firestore());
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    firebase.firestore().collection('pending').add({
      ...project,
      editedAt: timestamp
    }).then(() => {
      dispatch({ type: 'EDIT_PROJECT_SUCCESS' });
      callback();
    }).catch(err => {
      dispatch({ type: 'EDIT_PROJECT_ERROR' }, err);
    });
  }
};

export const updatePlayerChoices = (restaurantId, gameId, choice, userId, newChoices, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const choiceRef = firebase.firestore().collection('games').doc(gameId);
    const choiceString = "playerChoices."+userId;
    choiceRef.get().then((doc)=>{if (doc.exists){
      choiceRef.update({[choiceString]:newChoices}).then(() => {
      dispatch({ type: 'ADD_POINTS_SUCCESS' });
      callback();
    }).catch(err => {
      dispatch({ type: 'ADD_POINTS_ERROR' }, err);
    });}
      else {
      dispatch({ type: 'ADD_POINTS_ERROR' });
      }
  })
  }
};

export const editCreateRestaurant = (project, id, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const editorId = getState().firebase.auth.uid;
    firebase.firestore().collection('pendingCreate').doc(id).update({
      ...project,
      editorId: editorId,
      editedAt: new Date()
    }).then(() => {
      dispatch({ type: 'EDIT_CREATE_PROJECT_SUCCESS' });
      callback();
    }).catch(err => {
      dispatch({ type: 'EDIT_CREATE_PROJECT_ERROR' }, console.log(err));
    });
  }
};

export const pendingEditRestaurant = (project, id, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('pending').doc(id).update({
      ...project
    }).then(() => {
      dispatch({ type: 'PENDING_EDIT_PROJECT_SUCCESS' });
      callback();
    }).catch(err => {
      dispatch({ type: 'PENDING_EDIT_PROJECT_ERROR' }, console.log(err));
    });
  }
};

export const confirmEditRestaurantAdmin = (project, id) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('restaurants').doc(id).update({
      ...project
    }).then(() => {
      dispatch({ type: 'ADMIN_CONFIRM_EDIT_PROJECT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADMIN_CONFIRM_EDIT_PROJECT_ERROR' }, err);
    });
  }
};

export const confirmCreateRestaurantAdmin = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('restaurants').doc(project.id).set({
      ...project,
      restaurantId: project.id
    }).then(() => {
      dispatch({ type: 'ADMIN_CONFIRM_PROJECT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADMIN_CONFIRM_PROJECT_ERROR' }, err);
    });
  }
};

export const addUserPointsAdmin = (id, userId, points) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const pointsRef = firebase.firestore().collection('points').doc(userId);

    pointsRef.get().then((doc)=>{if (doc.exists){
      pointsRef.update({[id]:parseInt(points)}).then(() => {
      dispatch({ type: 'ADD_POINTS_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADD_POINTS_ERROR' }, err);
    });}
      else {
       pointsRef.set({[id]:parseInt(points)}).then(() => {
      dispatch({ type: 'ADD_POINTS_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADD_POINTS_ERROR' }, err);
    }); 
      }
  })
  }
};



export const deleteRestaurantAdmin = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('pending').doc(project.id).delete().then(() => {
      dispatch({ type: 'ADMIN_DELETE_PROJECT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADMIN_DELETE_PROJECT_ERROR' }, err);
    });
  }
};

export const deleteFullRestaurantAdmin = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('restaurants').doc(project.restaurantId).delete().then(() => {
      dispatch({ type: 'ADMIN_FULL_DELETE_PROJECT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADMIN_FULL_DELETE_PROJECT_ERROR' }, err);
    });
  }
};

export const deleteRestaurantCreateAdmin = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('pendingCreate').doc(project.id).delete().then(() => {
      dispatch({ type: 'ADMIN_DELETE_CREATE_PROJECT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'ADMIN_DELETE_CREATE_PROJECT_ERROR' }, err);
    });
  }
};

export const deleteMessage = (userId, messageId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/'+userId+'/messages/').doc(messageId).delete().then(() => {
      dispatch({ type: 'DELETE_MESSAGE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_MESSAGE_ERROR' }, console.log(err));
    });
  }
};

export const deleteReviewMessage = (userId, messageId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/'+userId+'/reviewMessages/').doc(messageId).delete().then(() => {
      dispatch({ type: 'DELETE_REVIEW_MESSAGE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_REVIEW_MESSAGE_ERROR' }, console.log(err));
    });
  }
};

export const deleteIssueMessage = (userId, messageId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/'+userId+'/issueMessages/').doc(messageId).delete().then(() => {
      dispatch({ type: 'DELETE_ISSUE_MESSAGE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_ISSUE_MESSAGE_ERROR' }, console.log(err));
    });
  }
};

export const deleteAdminMessage = (adminMessageId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const adminId = getState().firebase.auth.uid;
    firebase.firestore().collection('users/'+adminId+'/adminMessages/').doc(adminMessageId).delete().then(() => {
      dispatch({ type: 'DELETE_ADMIN_MESSAGE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_ADMIN_MESSAGE_ERROR' }, console.log(err));
    });
  }
};

export const deleteAdminReviewMessage = (adminMessageId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const adminId = getState().firebase.auth.uid;
    firebase.firestore().collection('users/'+adminId+'/adminReviewMessages/').doc(adminMessageId).delete().then(() => {
      dispatch({ type: 'DELETE_ADMIN_REVIEW_MESSAGE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_ADMIN_REVIEW_MESSAGE_ERROR' }, console.log(err));
    });
  }
};

export const deleteAdminIssueMessage = (adminMessageId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const adminId = getState().firebase.auth.uid;
    firebase.firestore().collection('users/'+adminId+'/adminIssueMessages/').doc(adminMessageId).delete().then(() => {
      dispatch({ type: 'DELETE_ADMIN_ISSUE_MESSAGE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_ADMIN_ISSUE_MESSAGE_ERROR' }, console.log(err));
    });
  }
};

export const deleteGuestUser = (userId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/').doc(userId).delete().then(() => {
      dispatch({ type: 'DELETE_GUEST_USER_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_GUEST_USER_ERROR' }, console.log(err));
    });
  }
};

export const deleteGuestUserFavorites = (userId, favId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/'+userId+'/favorites/').doc(favId).delete().then(() => {
      dispatch({ type: 'DELETE_GUEST_USER_FAVS_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_GUEST_USER__FAVS_ERROR' }, console.log(err));
    });
  }
};



export const deleteChat = (userId, messageId, chatId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/'+userId+'/messages/'+messageId+'/chat').doc(chatId).delete().then(() => {
      dispatch({ type: 'DELETE_CHAT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_CHAT_ERROR' }, console.log(err));
    });
  }
};

export const deleteReviewChat = (userId, messageId, chatId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/'+userId+'/reviewMessages/'+messageId+'/chat').doc(chatId).delete().then(() => {
      dispatch({ type: 'DELETE_REVIEW_CHAT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_REVIEW_CHAT_ERROR' }, console.log(err));
    });
  }
};

export const deleteIssueChat = (userId, messageId, chatId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/'+userId+'/issueMessages/'+messageId+'/chat').doc(chatId).delete().then(() => {
      dispatch({ type: 'DELETE_ISSUE_CHAT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_ISSUE_CHAT_ERROR' }, console.log(err));
    });
  }
};


export const deleteReviewAdmin = (project, reviewId, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const revId = reviewId?reviewId:project.id;
    firebase.firestore().collection('pendingReviews/').doc(revId).delete().then(() => {
      dispatch({ type: 'DELETE_REVIEW_SUCCESS' });
      if(callback){callback()}
    }).catch(err => {
      dispatch({ type: 'DELETE_REVIEW_ERROR' }, console.log(err));
    });
  }
};

export const deleteIssueAdmin = (issueId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('issues/').doc(issueId).delete().then(() => {
      dispatch({ type: 'DELETE_ISSUE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_ISSUE_ERROR' }, console.log(err));
    });
  }
};

export const deleteUserReviewAdmin = (project, reviewId, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('restaurantReviews2').doc(reviewId).delete().then(() => {
      dispatch({ type: 'DELETE_USER_REVIEW_SUCCESS' });
      if(callback){callback()}
    }).catch(err => {
      dispatch({ type: 'DELETE_USER_REVIEW_ERROR' }, console.log(err));
    });
  }
};

export const backupReviewAdmin = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('deletedReviews').add({
      ...project,
      deletedAt: new Date()
    }).then(() => {
      dispatch({ type: 'BACKUP_REVIEW_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'BACKUP_REVIEW_ERROR' }, err);
    });
  }
};

export const newDistance = (distanceList) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('GUDistanceList').add({
      ...distanceList
    }).then(() => {
      dispatch({ type: 'BACKUP_REVIEW_SUCCESS' }, console.log('suc'));
    }).catch(err => {
      dispatch({ type: 'BACKUP_REVIEW_ERROR' }, console.log(err));
    });
  }
};

export const backupIssueAdmin = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('deletedIssues').add({
      ...project,
      deletedAt: new Date()
    }).then(() => {
      dispatch({ type: 'BACKUP_ISSUE_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'BACKUP_ISSUE_ERROR' }, err);
    });
  }
};

export const backupUserReviewAdmin = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('deletedUserReviews').add({
      ...project,
      deletedAt: new Date()
    }).then(() => {
      dispatch({ type: 'BACKUP_USER_REVIEW_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'BACKUP_USER_REVIEW_ERROR' }, err);
    });
  }
};

export const backupRestaurantAdmin = (project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('deleted').add({
      ...project,
      deletedAt: new Date()
    }).then(() => {
      dispatch({ type: 'BACKUP_PROJECT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'BACKUP_PROJECT_ERROR' }, err);
    });
  }
};

export const backupMessage = (userId, messageId, message, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/' + userId +'/deletedMessages').add({
      ...message,
      deletedAt: new Date()
    }).then(() => {
      dispatch({ type: 'BACKUP_MESSAGE_SUCCESS' });
      if(callback){callback()};
    }).catch(err => {
      dispatch({ type: 'BACKUP_MESSAGE_ERROR' }, err);
    });
  }
};

export const backupReviewMessage = (userId, messageId, message, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/' + userId +'/deletedReviewMessages').add({
      ...message,
      deletedAt: new Date()
    }).then(() => {
      dispatch({ type: 'BACKUP_REVIEW_MESSAGE_SUCCESS' });
      if(callback){callback()};
    }).catch(err => {
      dispatch({ type: 'BACKUP_REVIEW_MESSAGE_ERROR' }, err);
    });
  }
};

export const backupIssueMessage = (userId, messageId, message, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.firestore().collection('users/' + userId +'/deletedIssueMessages').add({
      ...message,
      deletedAt: new Date()
    }).then(() => {
      dispatch({ type: 'BACKUP_ISSUE_MESSAGE_SUCCESS' });
      if(callback){callback()};
    }).catch(err => {
      dispatch({ type: 'BACKUP_ISSUE_MESSAGE_ERROR' }, err);
    });
  }
};


export const createTicket = (message, project, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const senderId = getState().firebase.auth.uid;
    const userId = project.editorId?project.editorId:project.authorId;
    const messageRef = firebase.firestore().collection('users/' + userId + '/messages').doc();
      messageRef.set({
        message: message,
        senderId: senderId,
        project: project,
        timestamp: new Date()
      }).then(() => {
      console.log('docID');
      console.log(messageRef.id);
      dispatch({ type: 'ADD_TICKET_SUCCESS' });
      if(callback){callback(messageRef.id);}
      }).catch(err => {
      dispatch({ type: 'ADD_TICKET_ERROR' }, console.log(err));
      });
  }
};

export const createReviewTicket = (message, project, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const senderId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const messageRef = firebase.firestore().collection('users/' + project.userId + '/reviewMessages').doc();
      messageRef.set({
        message: message,
        senderId: senderId,
        project: project,
        timestamp: timestamp
      }).then(() => {
      console.log('docID');
      console.log(messageRef.id);
      dispatch({ type: 'ADD_REVIEW_TICKET_SUCCESS' });
      if(callback){callback(messageRef.id);}
      }).catch(err => {
      dispatch({ type: 'ADD_REVIEW_TICKET_ERROR' }, console.log(err));
      });
  }
};

export const createIssueTicket = (message, project, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const senderId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const messageRef = firebase.firestore().collection('users/' + project[1].userId + '/issueMessages').doc();
      messageRef.set({
        message: message,
        senderId: senderId,
        project: project,
        timestamp: timestamp
      }).then(() => {
      console.log('docID');
      console.log(messageRef.id);
      dispatch({ type: 'ADD_ISSUE_TICKET_SUCCESS' });
      if(callback){callback(messageRef.id);}
      }).catch(err => {
      dispatch({ type: 'ADD_ISSUE_TICKET_ERROR' }, console.log(err));
      });
  }
};


export const createAdminTicket = (messageId, userId, project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const senderId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const messageRef = firebase.firestore().collection('users/' + senderId + '/adminMessages').doc();
      messageRef.set({
        messageId: messageId,
        timestamp: timestamp,
        adminId: senderId,
        senderId: userId,
        project: project
      }).then(() => {
      dispatch({ type: 'ADD_ADMIN_TICKET_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_ADMIN_TICKET_ERROR' }, console.log(err));
      });
  }
};


export const createAdminReviewTicket = (messageId, userId, project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const senderId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const messageRef = firebase.firestore().collection('users/' + senderId + '/adminReviewMessages').doc();
      messageRef.set({
        messageId: messageId,
        senderId: userId,
        timestamp: timestamp,
        adminId: senderId,
        project: project
      }).then(() => {
      dispatch({ type: 'ADD_ADMIN_REVIEW_TICKET_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_ADMIN_REVIEW_TICKET_ERROR' }, console.log(err));
      });
  }
};

export const createAdminIssueTicket = (messageId, userId, project) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const senderId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const messageRef = firebase.firestore().collection('users/' + senderId + '/adminIssueMessages').doc();
      messageRef.set({
        messageId: messageId,
        senderId: userId,
        timestamp: timestamp,
        adminId: senderId,
        project: project
      }).then(() => {
      dispatch({ type: 'ADD_ADMIN_ISSUE_TICKET_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_ADMIN_ISSUE_TICKET_ERROR' }, console.log(err));
      });
  }
};

export const createMessage = (message, userId, messageId, senderId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    // const senderId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const messageRef = firebase.firestore().collection('users/' + userId + '/messages/' + messageId +'/chat');
      messageRef.add({
        message: message,
        senderId: senderId,
        timestamp:timestamp
      }).then(() => {
      dispatch({ type: 'ADD_MESSAGE_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_MESSAGE_ERROR' }, console.log(err));
      });
  }
};

export const createReviewMessage = (message, userId, messageId, senderId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    // const senderId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const messageRef = firebase.firestore().collection('users/' + userId + '/reviewMessages/' + messageId +'/chat');
      messageRef.add({
        message: message,
        senderId: senderId,
        timestamp:timestamp
      }).then(() => {
      dispatch({ type: 'ADD_REVIEW_MESSAGE_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_REVIEW_MESSAGE_ERROR' }, console.log(err));
      });
  }
};

export const createIssueMessage = (message, userId, messageId, senderId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    //const senderId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const messageRef = firebase.firestore().collection('users/' + userId + '/issueMessages/' + messageId +'/chat');
      messageRef.add({
        message: message,
        senderId: senderId,
        timestamp:timestamp
      }).then(() => {
      dispatch({ type: 'ADD_ISSUE_MESSAGE_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_ISSUE_MESSAGE_ERROR' }, console.log(err));
      });
  }
};

export const confirmReviewAdmin = (review, restaurantId, userId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const adminId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const firstRef = firebase.firestore().collection('restaurantReviews/').doc(restaurantId);
    const reviewRef = firebase.firestore().collection('restaurantReviews/' + restaurantId + '/reviews').doc(userId);
    firstRef.set({updated:timestamp}).then(()=>{
      reviewRef.set({
        userId: userId,
        review: review,
        timestamp:timestamp,
        adminId: adminId
      }).then(() => {
      dispatch({ type: 'ADD_REVIEW_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_REVIEW_ERROR' }, console.log(err));
      });
    })
  }
};

export const confirmReviewAdmin2 = (review, restaurantId, userId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const adminId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const reviewRef = firebase.firestore().collection('restaurantReviews2/');
      reviewRef.add({
        userId: userId,
        restaurantId: restaurantId,
        review: review,
        timestamp:timestamp,
        adminId: adminId
      }).then(() => {
      dispatch({ type: 'ADD_REVIEW_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_REVIEW_ERROR' }, console.log(err));
      });  
  }
};

export const confirmIssueAdmin2 = (issue) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const adminId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const issueRef = firebase.firestore().collection('issuesClosed/');
      issueRef.add({
        issue: issue,
        timestamp:timestamp,
        adminId: adminId
      }).then(() => {
      dispatch({ type: 'CLOSE_ISSUE_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'CLOSE_ISSUE_ERROR' }, console.log(err));
      });  
  }
};

export const confirmUserReviewAdmin = (review, restaurantId, userId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const adminId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const firstRef = firebase.firestore().collection('users/').doc(userId);
    const reviewRef = firebase.firestore().collection('users/' + userId + '/reviews').doc(restaurantId);
    firstRef.update({updated:timestamp}).then(()=>{
      reviewRef.set({
        review: review,
        timestamp:timestamp,
        adminId: adminId
      }).then(() => {
      dispatch({ type: 'ADD_USER_REVIEW_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_USER_REVIEW_ERROR' }, console.log(err));
      });
    })
  }
};

export const createReview = (review, restaurantId, callback) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const messageRef = firebase.firestore().collection('pendingReviews/').doc();
      messageRef.set({
        review:review.review,
        oneStar:review.oneStar,
        twoStar:review.twoStar,
        threeStar:review.threeStar,
        fourStar:review.fourStar,
        fiveStar:review.fiveStar,
        reviewScore:review.reviewScore,
        userId: userId,
        timestamp:timestamp,
        restaurantId:restaurantId,
        name:review.name
      }).then(() => {
      dispatch({ type: 'ADD_PENDING_REVIEW_SUCCESS' });
      if(callback){callback()}
      }).catch(err => {
      dispatch({ type: 'ADD_PENDING_REVIEW_ERROR' }, console.log(err));
      });
  }
};

export const createIssue = (message) => {
  return(dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const userId = getState().firebase.auth.uid;
    const messageRef = firebase.firestore().collection('issues/').doc();
      messageRef.set({
        message:message,
        userId:userId,
        timestamp:timestamp
      }).then(() => {
      dispatch({ type: 'ADD_ISSUE_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'ADD_ISSUE_ERROR' }, console.log(err));
      });      
  }
}

export const linkReview = (review, restaurantId) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const reviewRef = firebase.firestore().collection('restaurants/' + restaurantId + '/reviews').doc(userId);
      reviewRef.set({
        review: review,
        timestamp:timestamp
      }).then(() => {
      dispatch({ type: 'LINK_REVIEW_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'LINK_REVIEW_ERROR' }, console.log(err));
      });
  }
};

export const setDistanceList = (distanceList, user) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const distanceRef = firebase.firestore().collection('users/').doc(userId);
      distanceRef.update({
        ...user,
        distanceList: distanceList,
        timestamp: timestamp
      }).then(() => {
      dispatch({ type: 'UPDATE_DISTANCES_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_DISTANCES_ERROR' }, console.log(err));
      });
  }
};

export const setUserDistanceList = (distanceList, user, callback) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const distanceRef = firebase.firestore().collection('users/').doc(userId);
    console.log('set user distances')
      distanceRef.update({
        ...user,
        distanceList: distanceList,
        timestamp: timestamp
      }).then(() => {
      dispatch({ type: 'UPDATE_DISTANCES_SUCCESS' });
      if(callback){
        callback();  
      };
      }).catch(err => {
      dispatch({ type: 'UPDATE_DISTANCES_ERROR' }, console.log(err));
      });
  }
};

export const updateReviewCount = (project, reviewCount) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    // const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const reviewRef = firebase.firestore().collection('restaurants/').doc(project.restaurantId);
      reviewRef.update({
        ...project,
        reviewCount: reviewCount,
        timestamp: timestamp
      }).then(() => {
      dispatch({ type: 'UPDATE_REVIEW_COUNT_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_REVIEW_COUNT_ERROR' }, console.log(err));
      });
  }
};


export const setAddress = (state, zip, city, address, location, user) => {
    return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    const addressRef = firebase.firestore().collection('users/').doc(userId);
      addressRef.update({
        ...user,
        distanceList: false,
        state:state,
        zip:zip,
        city:city,
        address:address,
        location:location,
        timestamp:timestamp
      }).then(() => {
      dispatch({ type: 'UPDATE_ADDRESS_SUCCESS' });
      }).catch(err => {
      dispatch({ type: 'UPDATE_ADDRESS_ERROR' }, console.log(err));
      });
  }
};

export const sortRestaurants = (newProjects) => {
  return (dispatch, getState) => {
    const currentState = getState();
    if (JSON.stringify(currentState.newProjects) !== JSON.stringify(newProjects)){
      dispatch({ type: 'SORT_RESTAURANTS_SUCCESS', payload:newProjects})  
    }  
  }
};

export const updateSortOptions = (sortOptions) => {
  return (dispatch, getState) => {
    const currentState = getState();
    if (JSON.stringify(currentState.sortOptions) !== JSON.stringify(sortOptions)){
      dispatch({ type: 'UPDATE_SORT_OPTIONS_SUCCESS', payload:sortOptions})  
    }
  }
};

export const updateSortVisible = (sortVisible) => {
  return (dispatch) => {
    dispatch({type: 'UPDATE_SORT_VISIBLE_SUCCESS', payload:sortVisible})
  }
};
